/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'photo-icon': {
    width: 30,
    height: 25,
    viewBox: '0 0 30 25',
    data: '<path pid="0" d="M15 9.767c2.527 0 4.567 2.042 4.567 4.534 0 2.49-2.07 4.503-4.567 4.503-2.497 0-4.567-2.011-4.567-4.503S12.473 9.767 15 9.767zm10.9-5.403h.001c1.98 0 3.562 1.56 3.593 3.483l-.001 13.568c0 1.951-1.614 3.512-3.562 3.512H4.099c-1.979 0-3.562-1.591-3.562-3.512V7.847c0-1.922 1.583-3.483 3.562-3.483h4.477l1.37-2.702c.305-.6.944-.99 1.644-.99h6.821c.7 0 1.34.39 1.644.99l1.37 2.702h4.476zM6.659 9.527l-.002-1.26c0-.48-.394-.87-.882-.87H4.495a.877.877 0 00-.882.87l.001 1.26c0 .48.395.87.883.87h1.278c.487 0 .883-.39.883-.87zM15 20.994c3.745 0 6.79-3.002 6.79-6.695 0-3.692-3.045-6.694-6.79-6.694s-6.79 3.002-6.79 6.694c0 3.693 3.045 6.695 6.79 6.695z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
